<template>
  <div class="row">
    <b-modal
      size="lg"
      no-close-on-backdrop
      hide-footer
      id="new_finance_configuration_category"
      title="NOVA CATEGORIA"
    >
      <NewCatgegory @success="handleSuccessCategory" />
    </b-modal>
    <div class="col-md-12 text-right pb-0">
      <v-btn
        class="btn-add"
        @click="$bvModal.show('new_finance_configuration_category')"
        ><i class="fas fa-plus mr-2"></i> NOVA</v-btn
      >
    </div>
    <div class="col-md-12 pt-0">
      <label>CATEGORIA</label>
      <treeselect
        :options="[
          { id: '', label: 'NÃO INFORMAR', children: [] },
          ...finance_configuration_category,
        ]"
        placeholder="SELECIONE..."
        v-model="finance_configuration_category_id"
        noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
      />
    </div>
    <div class="col-md-12">
      <errors-messages :errors="errors" />
    </div>
    <div class="col-md-12 text-right">
      <v-btn :disabled="loading" @click="execute" class="btn-save">
        <i class="fas fa-save mr-2 text-twenty"></i>
        {{ loading ? "Carregando" : "SALVAR" }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";

import Treeselect from "@riophae/vue-treeselect";

import NewCatgegory from "../../../Financial/Configuration/Categories/Create";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

export default {
  name: "FinanceConfigurationCategory",

  components: {
    ErrorsMessages,
    Treeselect,
    NewCatgegory,
  },

  props: {
    category_id: { type: [Number, String] },
    stock_item_id: { type: [Number, String] },
    finance_configuration_category: { type: Array },
  },

  data() {
    return {
      finance_configuration_category_id: "",

      loading: false,
      errors: [],
    };
  },

  created() {
    this.finance_configuration_category_id = this.category_id
      ? this.category_id
      : "";
  },

  methods: {
    async handleSuccessCategory(id) {
      this.$bvModal.hide("new_finance_configuration_category");
      this.$emit("get_finance_configuration_category");
      this.finance_configuration_category_id = id;
    },

    async execute() {
      try {
        this.loading = true;

        let { stock_item_id, finance_configuration_category_id } = this;

        const data = {
          stock_item_id,
          finance_configuration_category_id,
        };

        const response = await api.put(
          "/rest-home/stock/items/product/finance-configuration-category",
          data
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          toast(message, "success");
          this.$emit("success");
          this.$bvModal.hide("new_finance_configuration_category");
          this.$bvModal.hide("finance_configuration_category");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
